import { type FC, useState } from "react";
import type {
  Division,
  PhotoContestEntry,
  PhotoContestGuidelines,
  RemainingVotableCountsByDivision,
} from "@clientFrontend/features/campaign/components/UserPhotoContest/type";
import { Presentation } from "./Presentation";

type Props = {
  contestEntries: PhotoContestEntry[];
  contestGuidelines: PhotoContestGuidelines;
  votePath: string;
  commentPath: string;
  isClientScoutable: boolean;
  isVotingPeriodOver: boolean;
  initialClientRemainingVotableCounts: RemainingVotableCountsByDivision;
};

export const UserPhotoContest: FC<Props> = ({
  contestEntries,
  contestGuidelines,
  votePath,
  commentPath,
  isClientScoutable,
  isVotingPeriodOver,
  initialClientRemainingVotableCounts,
}) => {
  const [clienRemainingVotableCounts, setClienRemainingVotableCounts] =
    useState<RemainingVotableCountsByDivision>(initialClientRemainingVotableCounts);
  const [activeTab, setActiveTab] = useState<Division>("model");

  return (
    <Presentation
      contestEntries={contestEntries}
      contestGuidelines={contestGuidelines}
      votePath={votePath}
      commentPath={commentPath}
      isClientScoutable={isClientScoutable}
      isVotingPeriodOver={isVotingPeriodOver}
      clienRemainingVotableCounts={clienRemainingVotableCounts}
      setClienRemainingVotableCounts={setClienRemainingVotableCounts}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
    />
  );
};
